import React from 'react';
import DeliveryAPIError from 'components/contentstack/DeliveryAPIError';
import ErrorPage from 'components/contentstack/ErrorPage';
import ContentstackRenderer from 'components/contentstack/renderer';
import MetaDataComponent from 'components/SEO/MetaDataComponent';
import { useFormat } from 'helpers/hooks/useFormat';

const ContentstackPageSingleTastic = ({ data }: any) => {
  const { formatMessage } = useFormat({ name: 'common' });

  const content = data?.data?.dataSource[0] as any;

  if (!content) {
    return <ErrorPage />;
  }

  if (content?.err) {
    return <DeliveryAPIError data={content.err} />;
  }

  const meta = content.data.meta_data ?? {};

  let metaTitle = meta?.meta_title ?? content.data.title;
  let metaDescription = meta?.meta_description;

  if (content.contentTypeUid === 'home_page') {
    metaTitle =
      content.data.title ??
      formatMessage({
        id: 'meta.title',
        defaultMessage: 'Nikon | Shop & Explore Cameras, Lenses, and Accessories',
      });

    metaDescription =
      meta?.meta_description ??
      formatMessage({
        id: 'meta.desc',
        defaultMessage:
          'Shop the latest mirrorless & DSLR cameras and NIKKOR lenses from the official Nikon eCommerce site. Explore our innovations and photo equipment!',
      });
  }

  const metaData = {
    ...meta,
    meta_title: metaTitle,
    meta_description: metaDescription,
  };

  return (
    <>
      <MetaDataComponent content={metaData} tasticName="ContentstackPageSingleTastic" />
      <ContentstackRenderer data={content.data} contentTypeUid={content.contentTypeUid} />
    </>
  );
};

export default ContentstackPageSingleTastic;
